module.exports = __webpack_public_path__ + "img/6.cb4c83c7.png";